<div class="body">
    <div class="image-wrapper">

        <ng-container *ngIf="hasProfilePicture; else noProfilePicture">

            <img class="profile-picture" [src]=profilePictureData />

        </ng-container>

        <ng-template #noProfilePicture>

            <div class="initials">
                {{initials}}
            </div>

        </ng-template>

    </div>
    <div class="content-wrapper">
        <div class="username">
            {{name}}
        </div>
        <div class="e-mail">
            {{eMail}}
        </div>
    </div>
</div>